import React from 'react';
import PropTypes from 'prop-types';
import { flowRight } from 'lodash';
import { SIDEBAR } from '../../constants/bi-locations';
import classNames from 'classnames';
import Link from '../link/internal-link';
import PostPageSidebarCategoryListItem from './post-page-sidebar-category-list-item';
import { getSubcategories } from '../../services/categories-service';
import withTranslate from '../../../common/components/with-translate/with-translate';
import withDividerColor from '../../hoc/with-divider-color';
import styles from './post-page-sidebar-category-list.scss';
import withCardBorderWidth from '../../hoc/with-card-border-width';

const HOME = '/';
const CATEGORIES_LIMIT = 5;

const PostPageSidebarCategoryList = ({
  categories,
  dividerColor,
  allCategories,
  borderWidth,
  t,
}) => {
  const renderCategories = () => {
    const items = [];
    categories.slice(0, CATEGORIES_LIMIT).forEach(category => {
      const totalCategories = items.reduce((acc, cur) => acc + cur.subcategories.length + 1, 0);
      if (totalCategories < CATEGORIES_LIMIT) {
        const item = {
          category,
          subcategories: getSubcategories(allCategories, category._id).slice(
            0,
            CATEGORIES_LIMIT - totalCategories - 1,
          ),
        };
        items.push(item);
      }
    });

    return items.map(item => (
      <PostPageSidebarCategoryListItem
        category={item.category}
        subcategories={item.subcategories}
      />
    ));
  };
  return (
    <section
      className={classNames(styles.categoryListContainer, 'forum-text-color')}
      style={{ borderColor: dividerColor, borderWidth }}
    >
      <span className={styles.title}>{t('post-page-sidebar-category-list.title')}</span>
      {categories && renderCategories()}
      <Link to={HOME} className="button-color" biLocation={SIDEBAR}>
        {t('post-page-sidebar-category-list.see-all-categories')}
      </Link>
    </section>
  );
};

PostPageSidebarCategoryList.propTypes = {
  categories: PropTypes.array.isRequired,
  allCategories: PropTypes.array.isRequired,
  borderWidth: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default flowRight(
  withTranslate,
  withDividerColor,
  withCardBorderWidth,
)(PostPageSidebarCategoryList);
